export const SIGNAL_META = {
  relevant:   { glyph: "✓", color: "#2e8b57", bg: "rgba(46,139,87,0.16)",  label: "relevant" },
  borderline: { glyph: "~", color: "#c79a2c", bg: "rgba(199,154,44,0.18)", label: "borderline" },
  wrong:      { glyph: "✗", color: "#b04545", bg: "rgba(176,69,69,0.18)",  label: "wrong" },
  cleared:    { glyph: "○", color: "#7a7a8a", bg: "rgba(160,160,176,0.10)", label: "cleared" },
};

export const SIGNAL_ORDER = ["relevant", "borderline", "wrong", "cleared"];
